export default __webpack_public_path__ + "static/media/sparkles_grey.3c3f5612.svg";